import classnames from 'classnames';
import React, { useEffect } from 'react';
import Input from 'shared/Inputs/Input';
import { BACKEND_DATE_FORMAT, format, hasFormat } from 'utils/date';

import InputWrapper from '../InputWrapper/InputWrapper';
import styles from './TextField.module.scss';

import { Props } from './TextField.types';
import variants from './variants';
import { VARIANTS_TYPES } from './variants.types';

const TextField: React.FC<Props> = ({
  field,
  type,
  placeholder,
  form,
  disabled,
  handleBlur,
  title,
  subtitle,
  readOnly,
  extraContent = [],
  debounceMs,
  variant = VARIANTS_TYPES.TEXT,
}) => {
  field.value = field.value === null ? '' : field.value;

  useEffect(() => {
    if (![VARIANTS_TYPES.DATE, VARIANTS_TYPES.DATETIME].includes(variant)) return;

    if (hasFormat(field.value, BACKEND_DATE_FORMAT)) {
      const dateFieldValue =
        variant === VARIANTS_TYPES.DATETIME
          ? format(field.value).dataTimeWithHoursAndMinutes()
          : format(field.value).fromBackendToView();
      form.setFieldValue(field.name, dateFieldValue);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <InputWrapper
      title={title}
      name={field.name}
      subtitle={subtitle}
      hasError={false}
      wasTouched={false}
      extraContent={extraContent}>
      <Input
        field={field}
        type={type}
        className={classnames('text-input', styles.input)}
        placeholder={placeholder}
        form={form}
        disabled={disabled}
        readOnly={readOnly}
        handleBlur={handleBlur}
        debounceMs={debounceMs}
        {...variants.get(variant)}
      />
    </InputWrapper>
  );
};

export default TextField;
